import { render } from "./MyNeeds.vue?vue&type=template&id=147c3627"
import script from "./MyNeeds.vue?vue&type=script&lang=js"
export * from "./MyNeeds.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__